import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { HttpsService } from './https.service';

@Injectable({
    providedIn: 'root'
})
export class UserService {
    subject: Subject<any> = new Subject<any>();
    observable: Observable<any> = this.subject.asObservable();

    constructor(private http: HttpsService,) { }

    getLifeCycleSignals(id: any): Observable<any> {
        return this.http.get('/TradeSignal/Parent/DTO/' + id);
    }

    getMarketSentiment(month: any): Observable<any> {
        // console.log(`/TradeSignal/Summary/MktSentiment/-${month}`);
        return this.http.get(`/TradeSignal/Summary/MktSentiment/-${month}`);
    }

    getSummaryBySignalType(): Observable<any> {
        return this.http.get('/TradeSignal/Summary/SignalType/');
    }

    getSummaryBysectorType(): Observable<any> {
        return this.http.get('/TradeSignal/Summary/Sector');
    }
    //https://73.123.212.68:5002/api/TradeSignal/Summary/Sector

    getPriceTechnicalsBySymbolAndDateRange(symbol: any, startDate: any, endDate: any): Observable<any> {

        // const parms = symbol + '/' + new Date(startDate).toISOString().split('T')[0] + '/' + new Date(endDate).toISOString().split('T')[0];
        return this.http.get(`/pricetechnicals/SymbolDateWithPrice/${symbol}/${startDate}/${endDate}`);
    }

    getPriceTechnicalsBySymbolAndDateRange1(symbol: any, startDate: any, endDate: any): Observable<any> {

        const parms = symbol + '/' + new Date(startDate).toISOString().split('T')[0] + '/' + new Date(endDate).toISOString().split('T')[0];
        // return this.http.get(`/pricetechnicals/SymbolDateWithPrice/` + parms);
        return this.http.get(`/price/SymbolDate/${symbol}/${startDate}/${endDate}`);
    }

    getPriceTechnicalsBySectorAndDateRange(sector: string, startDate: any, endDate: any): Observable<any> {
        const parms = sector + '/' + new Date(startDate).toISOString().split('T')[0] + '/' + new Date(endDate).toISOString().split('T')[0];
        return this.http.get('/pricetechnicals/SectorWithDateRange/' + parms);
    }

    getPriceTechnicalsByIndustryAndDateRange(industry: string, startDate: any, endDate: any): Observable<any> {
        const parms = industry + '/' + new Date(startDate).toISOString().split('T')[0] + '/' + new Date(endDate).toISOString().split('T')[0];
        return this.http.get('/pricetechnicals/IndustryWithDateRange/' + parms);
    }

    getInvestorHoldings(): Observable<any> {
        return this.http.get('/Investor/Holdings');
    }

    putInvestorHolding(data: any): Observable<any> {
        return this.http.put('/Investor/PutHolding/', data);
    }

    deleteInvestorHolding(id: any): Observable<any> {
        return this.http.delete('/Investor/DelHolding/' + id);
    }

    getIInvestorHoldingByHoldingId(id: any): Observable<any> {
        return this.http.get('/Investor/HoldingById/' + id);
    }

    get_take_this_signals(id: any): Observable<any> {
        return this.http.get('/MktSymbol/' + 560799);
    }

    profileget(): Observable<any> {
        return this.http.get('/Account/profile');
    }

    //holding -> piechart

    piechart_holding(): Observable<any> {
        return this.http.get('/Investor/Allocation');
    }

    //add holding symbol get

    get_symbol(data: any): Observable<any> {
        return this.http.get(`/MktSymbol/like/${data}`)
    }

    // circle data

    circle_data(): Observable<any> {
        return this.http.get('/MktSymbol/SectorList')
    }

    //contact -> signal

    contact_signal(data: any): Observable<any> {
        return this.http.put('/Message', data)
    }

    //edit profile

    edit_profile(data: any): Observable<any> {
        return this.http.post('/Account/Update', data)
    }

    //change pass

    change_pass(data: any): Observable<any> {
        return this.http.post('/account/pw', data)
    }

}
